enum ContractDurationTypeEnum {
    PERMANENT = 'PERMANENT',
    FIXED_TERM = 'FIXED_TERM',
}

export default ContractDurationTypeEnum;
